export interface AuthUser {
  guid: string;
  name: string;
  email: string;
  type?: string;
  photo_url?: string;
  [key: string]: unknown;
}

const INTERNAL_AUTH_KEY = 'auth';

function readJson<T>(key: string): T | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function getInternalAuth(): Record<string, any> | null {
  return readJson<Record<string, any>>(INTERNAL_AUTH_KEY);
}

function mapInternalUser(data: Record<string, any>): AuthUser | null {
  if (!data?.api_token || !data?.guid) return null;
  return {
    guid: data.guid,
    name: data.name ?? data.fullname ?? data.email ?? 'Usuario',
    email: data.email ?? '',
    type: data.is_superadmin ? 'superadmin' : data.is_admin ? 'admin' : 'user',
    photo_url: data.src ?? data.photo_url,
    company_guid: data.company_guid,
    company_name: data.company_name,
  };
}

export function getToken(): string | null {
  const internal = getInternalAuth();
  return internal?.api_token ?? null;
}

export function getStoredUser(): AuthUser | null {
  const internal = getInternalAuth();
  return internal ? mapInternalUser(internal) : null;
}

export function setAuth(_token: string, _user: AuthUser): void {
  // No sistema interno o login oficial grava localStorage.auth.
}

export function clearAuth(): void {
  localStorage.removeItem('agentstudio.token');
  localStorage.removeItem('agentstudio.user');
}

export function emitLogout(): void {
  window.dispatchEvent(new CustomEvent('auth:logout'));
}
